import React from 'react';
import { Popover } from 'antd';
import { Address, AddressGroup } from '../../../dtos/version.dto';
import { addressesInGroup } from '../../../utils/versionUtils';
import './inventory-utils.scss';
import Arrow from '@svg/chevron-down_20.svg?react';

type CellData = {
    displayName: string
}

const renderLabel = (label: string, className:string) => {
    return <span className={`data-label-wrapper ${className}`}>
        <label className={'data-label'} key={label}>{label}</label>
    </span>;
};

export const listCells = (data: CellData[], className: string, popoverContent?: JSX.Element) => {

    let popoverElement;

    if (popoverContent) {
        popoverElement = popoverContent;
    } else if (data.length > 1) {
        popoverElement = fullDataInfo(data, className);
    } else {
        popoverElement = null;
    }
    
    return <Popover content={popoverElement}
                    className={`${className}-cell`}
                    overlayClassName={`popover-list`}
                    showArrow={!!popoverElement}
                    placement={'bottomLeft'}>
        {data[0] && renderLabel(data[0].displayName, className)}
        {data.length > 1 && renderLabel(`+${data.length - 1}`, className)}
    </Popover>;

};

const viewSpecificAddressGroupInfo = (addressGroup: AddressGroup, fwAddresses: Address[]) => {
    return <div className="address-group-info">
        <div className="title">{addressGroup.displayName}</div>
        <div className="content">{addressGroup.description}</div>
        <div className="title addresses-title">Addresses</div>
        {addressesInGroup(addressGroup)
            .map(address =>
                <div key={address} className="content">{fwAddresses.find(addr => addr.id === address)?.value}</div>)}
    </div>;
};

export const addressGroupFullDataInfo = (data: AddressGroup[], fwAddresses: Address[]) => {
    return <div className="address-group-popover-list">
        {
            data.map(item => {
                return <Popover key={item.displayName} className="popover-item address-group-popover-item"
                                overlayClassName={'popover-item-info'}
                                content={viewSpecificAddressGroupInfo(item, fwAddresses)}
                                showArrow={false} placement={'right'}>
                    <div>
                        <span>{item.displayName} ({addressesInGroup(item)?.length})</span>
                        <Arrow />
                    </div>
                </Popover>;
            })
        }
    </div>;
};

const fullDataInfo = (data: CellData[], className: string) => {
    return <div className={`${className}-popover-list`}>
        {
            data.map(item => {
                return <div className={`popover-item ${className}-popover-item`} key={item.displayName}>
                    <div>{item.displayName}</div>
                </div>;
            })
        }
    </div>;
};

export const DisplayNameCell = (props: { displayName: string }) => {
    const { displayName } = props;
    return <div title={displayName.length > 23 ? displayName : ''} className="truncated-text">{displayName}</div>;
};
